<template>
  <div class="pvd-display-row">
    <pvd-modal
      v-if="showHelp"
      :id="`${id}-modal`"
      :for="`${id}-modal-trigger`"
      :class="helpSize"
    >
      <div slot="modal-header">
        <h2 class="pvd-heading-L">
          {{ helpHeader }}
        </h2>
      </div>
      <div slot="modal-body">
        <div class="pvd-container">
          <p>
            {{ helpBody }}
          </p>
        </div>
      </div>
    </pvd-modal>
    <div class="display-row-label">
      <p>
        <a
          v-if="showHelp"
          :id="`${id}-modal-trigger`"
          href="javascript:void(0);"
        >
          <pvd-icon
            data-v-6e60c119=""
            icon="help"
            class="m-small-left"
          />
        </a> {{ label }}
      </p>
    </div>
    <div
      v-if="!showAnchor"
      class="display-row-content"
    >
      <p
        v-for="value in values"
        :key="value"
        :data-pii="mask"
      >
        {{ value }}
      </p>
    </div>
    <div
      v-if="showAnchor"
      class="display-row-content"
    >
      <p>
        <a
          class="edit-content"
          href="#"
          @click.prevent="handleClick()"
        >
          {{ anchorValue }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>

import dataHelper from '../mixins/dataHelper';
import navHelper from '../mixins/navHelper';
import utility from '../mixins/utility';

export default {
  name: 'ReadbackComponent',
  mixins: [dataHelper, navHelper, utility],
  props: {
    label: {
      type: String,
      default: '',
    },
    mask: {
      type: String,
      default: 'false',
    },
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    id: {
      type: String,
      default: '',
    },
    showHelp: {
      type: Boolean,
      default: false,
    },
    showAnchor: {
      type: Boolean,
      default: false,
    },
    helpHeader: {
      type: String,
      default: '',
    },
    helpBody: {
      type: String,
      default: '',
    },
    helpSize: {
      type: String,
      default: 'small',
    },
    pageName: {
      type: String,
      default: '',
    },
    anchorValue: {
      type: String,
      default: '',
    },
    userIndex: {
      type: Number,
      default: undefined,
    },
  },
  computed: {
  },
  methods: {
    handleClick() {
      this.handleEditClick(this.pageName, this.userIndex);
    },
  },
};
</script>

<style scoped>
</style>
